(() => {
  'use strict';

  const FREE_SHIPPING_TEXT = 'Free shipping within India for retail orders placed through this website';
  const FREE_SHIPPING_DESCRIPTION = 'Available only for retail purchases completed through this Shopify website. Excludes bulk, export, private-label and offline orders.';
  const RELEVANT_SELECTOR = '.haloCalculatorShipping, [data-shipping-message], .policies-text';
  let frameRequested = false;

  function applyFreeShippingCopy(root = document) {
    root.querySelectorAll('.haloCalculatorShipping').forEach((container) => {
      container.querySelectorAll('.message, [data-shipping-message]').forEach((element) => {
        element.textContent = FREE_SHIPPING_TEXT;
      });

      container.querySelectorAll('[class*="progress"], [class*="shipping-bar"]').forEach((element) => {
        element.hidden = true;
        element.setAttribute('aria-hidden', 'true');
      });
    });

    root.querySelectorAll('[data-shipping-message]').forEach((element) => {
      element.textContent = FREE_SHIPPING_TEXT;
    });

    root.querySelectorAll('.policies-text').forEach((title) => {
      if (!['Free Domestic Delivery', 'Retail Website Shipping'].includes(title.textContent.trim())) return;

      title.textContent = 'Retail Website Shipping';
      const content = title.closest('.content-inner') || title.parentElement;
      const description = content?.querySelector('.policies-des');

      if (description) description.textContent = FREE_SHIPPING_DESCRIPTION;
    });
  }

  function scheduleApply() {
    if (frameRequested) return;

    frameRequested = true;
    requestAnimationFrame(() => {
      frameRequested = false;
      applyFreeShippingCopy(document);
    });
  }

  function containsRelevantContent(node) {
    if (!(node instanceof Element)) return false;
    return node.matches(RELEVANT_SELECTOR) || Boolean(node.querySelector(RELEVANT_SELECTOR));
  }

  function start() {
    scheduleApply();

    const observerTarget = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper') || document.body;
    if (!observerTarget) return;

    const observer = new MutationObserver((mutations) => {
      const relevantChange = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some(containsRelevantContent)
      );

      if (relevantChange) scheduleApply();
    });

    observer.observe(observerTarget, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', scheduleApply);
})();
